module.exports = __webpack_public_path__ + "img/T1B_rc_14.10539422.png";